import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import en from './locales/en.json';
import es from './locales/es.json';
import ca from './locales/ca.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import nl from './locales/nl.json';
import da from './locales/da.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import ur from './locales/ur.json';

const resources = {
    en: { translation: en },
    es: { translation: es },
    ca: { translation: ca },
    fr: { translation: fr },
    de: { translation: de },
    it: { translation: it },
    pt: { translation: pt },
    nl: { translation: nl },
    da: { translation: da },
    ru: { translation: ru },
    zh: { translation: zh },
    ja: { translation: ja },
    ko: { translation: ko },
    ur: { translation: ur }
};

i18n
    .use(LanguageDetector) // Detect user language
    .use(initReactI18next) // Pass i18n instance to react-i18next
    .init({
        resources,
        fallbackLng: 'es', // Fallback language
        lng: 'es', // Default language
        interpolation: {
            escapeValue: false // React already escapes values
        },
        detection: {
            // Order of language detection
            order: ['localStorage', 'navigator'],
            caches: ['localStorage']
        }
    });

export default i18n;
